import { useState, useEffect } from 'react';

interface ViewPreferences {
  viewMode: 'grid' | 'list';
  truncateLength: number;
  showDescriptions: boolean;
}

const defaultPreferences: ViewPreferences = {
  viewMode: 'grid',
  truncateLength: 100,
  showDescriptions: true,
};

export function useViewPreferences() {
  const [preferences, setPreferences] = useState<ViewPreferences>(defaultPreferences);

  useEffect(() => {
    const stored = localStorage.getItem('viewPreferences');
    if (stored) {
      try {
        setPreferences({ ...defaultPreferences, ...JSON.parse(stored) });
      } catch (e) {
        console.error('Failed to parse view preferences:', e);
      }
    }
  }, []);

  const updatePreference = <K extends keyof ViewPreferences>(
    key: K,
    value: ViewPreferences[K]
  ) => {
    setPreferences(prev => {
      const updated = { ...prev, [key]: value };
      localStorage.setItem('viewPreferences', JSON.stringify(updated));
      return updated;
    });
  };

  const setViewMode = (mode: 'grid' | 'list') => updatePreference('viewMode', mode);
  const setTruncateLength = (length: number) => updatePreference('truncateLength', length);
  const setShowDescriptions = (show: boolean) => updatePreference('showDescriptions', show);

  return {
    ...preferences,
    setViewMode,
    setTruncateLength,
    setShowDescriptions,
  };
}
